import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { processEnv } from 'components/configuration/environmentVariables'
import React, { FC } from 'react'
import {
    advancedFilterDividerColor,
    advancedFilterHRColor,
    listingDialogFilterContainerColor,
} from 'shared/common/productListingDialogColors'
import { DialogContext } from '../DialogContext'
import { AdvancedFiltersProps } from './AdvancedFilters.types'
import AdvancedListingTypeFilter from './AdvancedListingTypeFilter'
import AdvancedProductFilter from './AdvancedProductFilter'
import AdvancedResourcesFilter from './AdvancedResourcesFilter'
import AdvancedSpecialtyFilter from './AdvancedSpecialtyFilter'
import ClearAllButton from './ClearAllButton'
import FilterPills from './FilterPills'

export const useAdvancedFiltersContainerStyles = makeStyles((theme: Theme) => ({
    advancedFiltersContainer: {
        display: 'flex',
        padding: '0 3rem',
        minHeight: '5rem',
        backgroundColor: listingDialogFilterContainerColor,
        borderTop: `1px solid ${advancedFilterHRColor}`,
        borderBottom: `1px solid ${advancedFilterHRColor}`,
    },
}))

const VerticalSeparator = () => {
    return (
        <Typography
            style={{
                width: 0,
                margin: '1rem 0',
                borderRight: `2px solid ${advancedFilterDividerColor}`,
            }}
        ></Typography>
    )
}

const AdvancedFilters: FC<AdvancedFiltersProps> = ({
    product,
    handleProduct,
    listingType,
    handleListingType,
    listingTypeOptions,
    sustainabilityResources,
    sustainabilityResourcesOptions,
    bimResources,
    bimResourcesOptions,
    handlePartnershipSelection,
    specialty,
    handleSpecialtyClick,
    specialtyOptions,
    handleClearAllClick,
    selectedTab,
}) => {
    const classes = useAdvancedFiltersContainerStyles()
    const {
        selectedManufacturers,
        handleToggleMultipleManufacturerSelections,
        handleSelectUnselectAllManufacturers,
    } = React.useContext(DialogContext)

    const hasSelectedManufacturers = (selectedManufacturers?.length ?? 0) > 0

    return (
        <GridContainer className={classes.advancedFiltersContainer}>
            <AdvancedProductFilter
                handleClick={handleProduct}
                product={product}
            />
            <VerticalSeparator />
            {// No need for listing type filter for unmapped products. 
                selectedTab === 0 && <>
                    <AdvancedListingTypeFilter
                        listingType={listingType}
                        listingTypeOptions={listingTypeOptions}
                        handleClick={handleListingType}
                    />
                    <VerticalSeparator />
                    <AdvancedSpecialtyFilter
                        handleClick={handleSpecialtyClick}
                        specialty={specialty}
                        specialtyOption={specialtyOptions}
                    />
                    <VerticalSeparator />
                </>
            }
            <AdvancedResourcesFilter
                resources={[
                    ...(sustainabilityResources ?? []),
                    ...(bimResources ?? []),
                ]}
                resourcesOptions={[
                    ...(sustainabilityResourcesOptions ?? []),
                    ...(bimResourcesOptions ?? []),
                ]}
                handleClick={handlePartnershipSelection!}
            />

            <ClearAllButton handleClearAllClick={handleClearAllClick} />
            
            {processEnv.REACT_APP_EnableDynamicManufacturerListSelection === '1' && (
                <>
                    <FilterPills
                        data-testid={`actionButton_selectUnselectAll`}
                        buttonText={hasSelectedManufacturers ? 'Unselect All' : 'Select All'}
                        key={'Select/Unselect All'}
                        handleClick={() =>
                            handleSelectUnselectAllManufacturers?.()
                        }
                        isActive={false}
                        disabled={false}
                    />
                    <FilterPills
                        data-testid={`actionButton_addToProject`}
                        buttonText={'Add to Project'}
                        key={'Add to Project'}
                        handleClick={() =>
                            handleToggleMultipleManufacturerSelections?.()
                        }
                        isActive={false}
                        disabled={!hasSelectedManufacturers}
                    />
                </>
            )}
        </GridContainer>
    )
}
export default AdvancedFilters
